PJQ.Errors = {
	auth: {
		INACTIVE: 'Your account is currently inactive, contact an administrator to activate it',
		INACTIVE_USER: 'Your account is currently inactive, contact an administrator to activate it',
		KEY_LENGTH: 'Access key must be 10 characters',
		NOT_FOUND: 'Access key not found',
		USER_NOT_FOUND: 'Unable to find an account with that username',
		LOCKED: 'Your account has been locked due to too many failed attempts',
		LOCKED_USER: 'Your account is currently locked',
		INCORRECT_PASSWORD: 'Incorrect password',
		INVALID_GRANT: 'Username does not exist or has been deleted',
		UNHANDLED: 'An error occurred, please contact customer service or try again later',
		USERNAME_EXISTS: 'Username already taken',
		CUSTOMER_SERVICE: 'An error occurred, please contact customer service or try again later',
		CURRENT_PASSWORD: 'You cannot use your current password',
		SSO_DISABLED: 'SSO is not enabled for this user',
		INVALID_SAML: 'Unable to validate SAML certificate, please contact your system administrator'
	}
};

PJQ.ErrorHandler = class {
	constructor(options = {}) {
		options = options != null ? options : {};
		options.handlers = _.defaults(options.handlers ? options.handlers : {}, {
			0: {
				notification: {
					type: 'error',
					message: 'Unable to connect.  Please verify you are still connected to the internet.',
					showContact: true
				}
			},
			400: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			401: {
				notification: {
					type: 'error',
					message: 'You do not have permission to view this {0}'
				}
			},
			404: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			405: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			500: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			502: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			503: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			504: {
				enableTracking: true,
				level: 'error',
				notification: {
					message: 'An error occurred',
					showContact: true
				}
			},
			default: {
				enableTracking: true,
			}
		});

		this.options = _.defaults(options ? options : {}, {});
	}

	handle(request, data) {
		let handler = this.options.handlers[request.status];
		if (handler != null) {
			if (handler.enableTracking && typeof Sentry === 'object') {
				Sentry.configureScope((scope) => {
					let sentryUserId = 0;
					if (PJQ.app.session.contact != null) {
						sentryUserId = PJQ.app.session.contact.id;
					}
					else if (PJQ.app.session.user != null) {
						sentryUserId = -PJQ.app.session.user.id;
					}
					scope.setUser({id: sentryUserId});
					scope.setLevel(handler.level ? handler.level : 'warning');
					scope.setExtra('statusCode', request.status);
					scope.setExtra('responseText', request.responseText);
					scope.setExtra('data', data);
					Sentry.captureMessage(request.status.toString() + ": " + request.url);
				});
			}

			if (handler.notification != null) {
				let itemName = handler.itemName != null ? handler.itemName : 'item';
				handler.notification.message = PJQ.helpers.stringHelpers.format(handler.notification.message, itemName);
				if (handler.level === 'warning' || handler.notification.type === 'warning') {
					PJQ.notifications.notify.warningNotify(handler.notification);
				}
				else {
					PJQ.notifications.notify.errorNotify(handler.notification);
				}
			}
		}
	}
};